import { Component, OnInit, Injectable, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment as env } from 'projects/insight/src/environments/environment';
import * as CryptoJS from 'crypto-js';
import { IStorageService } from '@insight/services';

@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

	constructor(
		private storageService: IStorageService,
		private activatedRoute: ActivatedRoute,
	) { }

	ngOnInit() {
		const returnUrl = this.activatedRoute.snapshot.queryParamMap.get('returnUrl');
		const codeVerifier = this.strRandom(128);
		this.storageService.set('ru', returnUrl);

		this.storageService.set('st', this.strRandom(40));
		const state = this.storageService.get('st');

		const codeVerifierHash = CryptoJS.SHA256(codeVerifier).toString(CryptoJS.enc.Base64);
		const codeChallenge = codeVerifierHash
			.replace(/=/g, '')
			.replace(/\+/g, '-')
			.replace(/\//g, '_');

		const params = [
			'st=' + state,
			'cid=' + env.apiKey,
			'cc=' + codeChallenge,
			'ru=' + env.authCallbackUrl
		];

		window.location.href = env.authUrl + '?' + params.join('&');
	}

	private strRandom(length: number) {
		let result = '';
		const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
		const charactersLength = characters.length;
		for (let i = 0; i < length; i++) {
			result += characters.charAt(Math.floor(Math.random() * charactersLength));
		}
		return result;
	}
}
